import React from "react";

const FlowPageHead = ({ title, back, actions }) => (
  <div className="sy-flow-head">
    <div className="sy-flow-head-main">
      <div className="sy-flow-backrow">{back}</div>

      {title && <h1 className="sy-flow-title">{title}</h1>}
    </div>

    {actions && <div className="sy-flow-head-actions">{actions}</div>}
  </div>
);

export default FlowPageHead;
